import axios from "axios";
import dropin from "braintree-web-drop-in"; // Import Braintree Drop-in
import { useState, useRef } from "react";
import Swal from "sweetalert2";

export const useBraintree = () => {
  const [braintreeInstance, setBraintreeInstance] = useState(null);
  const braintreeRef = useRef(null); // Ref for the Braintree Drop-in UI container

  const initializeBraintree = async () => {
    try {
      const clientTokenResponse = await axios.get(
        "/api/paymentmethod/getBraintreeToken"
      );
      const clientToken = clientTokenResponse.data.clientToken;

      dropin.create(
        {
          authorization: clientToken,
          container: braintreeRef.current,
        },
        (error, instance) => {
          if (error) {
            console.error("Error creating Braintree drop-in:", error);
          } else {
            setBraintreeInstance(instance);
          }
        }
      );
    } catch (error) {
      console.error("Error initializing Braintree:", error);
    }
  };

  const handleBraintreePayment = async () => {
    try {
      if (!braintreeInstance)
        throw new Error("Braintree instance not initialized");

      // Request payment method from Braintree Drop-in
      const { nonce } = await braintreeInstance.requestPaymentMethod();
      return nonce; // Return the nonce to use as transaction ID
    } catch (error) {
      console.error("Error processing Braintree payment:", error);
      Swal.fire(
        "Payment failed",
        "Braintree payment could not be completed.",
        "error"
      );
      throw error;
    }
  };

  return {
    initializeBraintree,
    handleBraintreePayment,
    braintreeRef,
  };
};
